module.exports = __webpack_public_path__ + "static/media/arrow_up.ec15ccfa.svg";